import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-file-unknown-fill",
  "use": "rt-portal-file-unknown-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-file-unknown-fill\">\r\n<path d=\"M854.6,288.7L639.4,73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7,0-32,14.3-32,32v832c0,17.7,14.3,32,32,32h640\r\n\tc17.7,0,32-14.3,32-32V311.3C864,302.8,860.6,294.7,854.6,288.7z M512,776c-17.7,0-32-14.3-32-32s14.3-32,32-32\r\n\tc17.7,0,32,14.3,32,32S529.7,776,512,776z M547.7,646.5c-5.7,1.8-9.7,7.3-9.7,13.3V672c0,5.5-4.5,10-10,10h-32c-5.5,0-10-4.5-10-10\r\n\tv-32c0.2-19.8,15.4-37.3,34.7-40.1C549,596.2,570,574.3,570,549c0-28.1-25.8-51.5-58-51.5s-58,23.4-58,51.6c0,5.2-4.4,9.4-9.8,9.4\r\n\th-32.4c-5.4,0-9.8-4.1-9.8-9.5c0-57.4,50.1-103.7,111.5-103c59.3,0.8,107.7,46.1,108.5,101.6C622.7,592.5,592.3,632.1,547.7,646.5z\r\n\t M602,326V137.8L790.2,326H602z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/file-unknown-fill.svg
// module id = 1850
// module chunks = 137